import React from "react";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";

import ReactPaginate from "react-paginate";
import styles from "./styles/Posts.module.scss";

export default function({postCounts, postsPerPage, pageUpdateHandler, paginationNumber }) {

	return (
		<Grid className="PostListingPagePagination">

			<Row>
				<Col xs={12} className={styles.PagenationCol}>

					<ReactPaginate
						previousLabel={"previous"}
						nextLabel={"next"}
						breakLabel={<a href="">...</a>}
						breakClassName={"break-me"}
						pageCount={postCounts/postsPerPage}
						marginPagesDisplayed={2}
						pageRangeDisplayed={2}
						containerClassName={styles.Pagenation + " pagination"}
						subContainerClassName={"pages pagination"}
						pageClassName={styles.PaginationNumLI}
						nextClassName={styles.PaginationNextLI}
						previousClassName={styles.PaginationPrevLI}
						activeClassName={"active"}
						onPageChange={pageUpdateHandler}
						forcePage={paginationNumber-1}
            disableInitialCallback={true}
					/>

				</Col>
			</Row>

		</Grid>
	);

}
